import React from "react";

// The Clozdl calligraphic "C" monogram, traced from the brand artwork.
// Renders as a single filled path so it stays crisp at any size. The glyph is
// pre-centered in a 512x512 viewBox, so it drops into square badges cleanly.
//
// `color` sets the fill (defaults to the brand gold). Pass a Tailwind text color
// via className + color="currentColor" if you want it to inherit.
export function ClozdlMark({ size = 32, color = "#C9B482", className = "", title = "Clozdl" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 512 512"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
            className={className}
        >
            <g transform="translate(47.5,74)">
                <g transform="translate(-49.99,389.73) scale(0.1,-0.1)" fill={color}>
                    <path d="M1895 3793 c-685 -87 -1168 -334 -1275 -653 -31 -92 -25 -213 14 -293 121 -248 547 -384 1134 -363 173 6 173 6 118 -71 -232 -333 -428 -753 -485 -1038 -52 -259 -35 -440 63 -700 20 -52 -90 90 -125 162 -174 356 -54 914 312 1460 27 39 50 76 51 82 2 7 -48 12 -149 15 -151 5 -151 5 -226 -107 -411 -616 -500 -1240 -224 -1574 351 -426 1303 -468 2197 -98 536 221 960 614 960 888 0 247 -336 268 -793 49 -113 -54 -247 -132 -202 -117 11 3 71 24 135 45 267 90 440 91 532 3 145 -139 -98 -481 -507 -717 -465 -268 -1133 -427 -1427 -339 -399 118 -576 563 -440 1104 62 244 221 586 409 877 30 46 59 84 66 86 7 2 71 9 142 15 864 78 1836 448 2290 872 153 144 120 251 -94 307 -90 23 -552 28 -720 8 -658 -80 -1438 -458 -1933 -935 -108 -103 -108 -103 -208 -87 -303 51 -523 173 -602 334 -43 86 -48 225 -11 304 109 236 556 411 1169 458 252 20 268 28 54 27 -107 0 -208 -2 -225 -4z m2258 -121 c117 -52 154 -159 97 -278 -68 -140 -397 -365 -722 -493 -287 -113 -878 -231 -1245 -248 -73 -3 -133 -3 -133 2 0 16 119 153 235 270 102 102 199 186 350 303 48 37 7 14 -87 -50 -139 -95 -326 -257 -464 -403 -129 -135 -129 -135 -191 -135 -35 0 -63 4 -63 9 0 5 42 48 92 97 515 489 1237 848 1913 948 57 8 177 -4 218 -22z" />
                </g>
            </g>
        </svg>
    );
}
